import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Accepts national numbers (e.g. 0612345678) and international numbers
 * (e.g. +212612345678, +33612345678), 8 to 15 digits, optional leading "+",
 * optional spaces/dots/dashes as separators.
 */
export const PHONE_NUMBER_REGEX = /^\+?[0-9](?:[\s.-]?[0-9]){7,14}$/;

export const PHONE_NUMBER_PLACEHOLDER = 'Numéro marocain ou international (ex: 0612345678 / +212612345678)';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return PHONE_NUMBER_REGEX.test(value.toString().trim()) ? null : { invalidPhoneNumber: true };
  };
}
